import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative space-y-6 lg:space-y-8 px-3 sm:px-4 lg:px-8 min-h-[calc(100vh-8rem)] pt-6" }
const _hoisted_2 = { class: "flex gap-2 -mt-2 mb-4 overflow-x-auto pb-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "bg-red-50 text-red-600 p-4 rounded-xl border border-red-200"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200/50 dark:border-slate-700/50 overflow-hidden"
}
const _hoisted_6 = { class: "min-w-full" }
const _hoisted_7 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute top-0 right-0 w-24 h-24 overflow-hidden pointer-events-none z-0"
}
const _hoisted_9 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "group relative inline-flex"
}
const _hoisted_11 = { class: "font-semibold text-base text-slate-800 dark:text-slate-100 mb-1.5 leading-snug" }
const _hoisted_12 = { class: "text-sm text-slate-500 dark:text-slate-400 flex-1 leading-relaxed" }
const _hoisted_13 = { class: "flex items-center justify-end mt-4 pt-4 border-t border-slate-100 dark:border-slate-800" }
const _hoisted_14 = {
  key: 0,
  disabled: "",
  class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 rounded-lg cursor-not-allowed"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  disabled: "",
  class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 rounded-lg cursor-not-allowed"
}
const _hoisted_17 = {
  key: 3,
  disabled: "",
  class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 rounded-lg cursor-not-allowed"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 3,
  class: "text-center py-12 text-slate-500"
}
const _hoisted_22 = {
  key: 4,
  class: "card border border-gray-200/50 dark:border-gray-700/50 shadow-sm sticky bottom-0 z-30"
}
const _hoisted_23 = { class: "p-4" }
const _hoisted_24 = { class: "space-y-4" }
const _hoisted_25 = { class: "text-sm text-slate-600 dark:text-slate-300" }
const _hoisted_26 = { class: "flex items-center gap-4 w-full" }
const _hoisted_27 = { class: "h-11 w-11 rounded-xl flex items-center justify-center bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200" }
const _hoisted_28 = { class: "min-w-0 flex-1 overflow-hidden" }
const _hoisted_29 = { class: "text-sm font-semibold text-gray-800 dark:text-gray-100 truncate" }
const _hoisted_30 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_31 = { class: "truncate" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["disabled"]

import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { materialService } from '@/services/material.service'
import { completedFormService } from '@/services/completedFormService'
import type { Material } from '@/config/types/material'
import type { CompletedForm } from '@/services/completedFormService'
import Modal from '@/components/layout/Modal.vue'
import MaterialDetailsModal from '@/components/materials/MaterialDetailsModal.vue'
import TableControls from '@/components/layout/TableControls.vue'
import PaginationBar from '@/components/layout/PaginationBar.vue'
import { useToast } from 'vue-toastification'
import { useAuthStore } from '@/stores/auth'
import TableLoader from '@/components/ui/TableLoader.vue'
import {
  Printer, Eye as ViewIcon,
  CloudDownload as DownloadIcon, Send, Info,
  FileText, Globe, Link2, CheckCircle, Upload, X
} from 'lucide-vue-next'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeMaterialsView',
  setup(__props) {

const toast = useToast()
const router = useRouter()
const authStore = useAuthStore()

const materials = ref<Material[]>([])
const completedForms = ref<CompletedForm[]>([])
const loading = ref(false)
const error = ref('')

const showDetailsModal = ref(false)
const selectedMaterial = ref<Material | null>(null)

const showSubmitModal = ref(false)
const currentFormMaterial = ref<Material | null>(null)
const selectedFiles = ref<File[]>([])
const isDragOver = ref(false)
const fileInputRef = ref<HTMLInputElement | null>(null)
const submitting = ref(false)

const searchQuery = ref('')
const statusFilter = ref('')
const typeFilter = ref('')

const statusOptions = [
  { label: 'All', value: '' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
]

const typeOptions = [
  { label: 'All Types', value: '' },
  { label: 'Document Files', value: 'Doc File' },
  { label: 'URL Links', value: 'URL Link' },
  { label: 'Online Forms', value: 'Online form' },
]

const userId = computed(() => authStore.currentUser?.id)
const positionId = computed(() => authStore.currentUser?.position_id)

const assignedMaterials = computed(() => {
  const uid = userId.value
  const pid = positionId.value
  if (!uid) return materials.value
  return materials.value.filter(m => {
    const posMatch = m.position_viewers?.some(p => p.id === pid)
    const userMatch = m.user_viewers?.some(u => u.id === uid)
    const noViewers = (!m.position_viewers || m.position_viewers.length === 0) &&
                      (!m.user_viewers || m.user_viewers.length === 0)
    return posMatch || userMatch || noViewers
  })
})

const completedMaterialIds = computed(() => {
  const uid = userId.value
  if (!uid) return new Set<number>()
  const ids = completedForms.value
    .filter(f => Number(f.user_id) === uid)
    .map(f => Number(f.fk_material_id ?? (f as any).material_id))
    .filter(Boolean)
  return new Set(ids)
})

const isCompleted = (m: Material) => {
  return completedMaterialIds.value.has(m.id)
}

const statusFiltered = computed(() => {
  const list = assignedMaterials.value
  if (!statusFilter.value) return list
  return list.filter(m => m.status === statusFilter.value)
})

const typeFiltered = computed(() => {
  const list = statusFiltered.value
  if (!typeFilter.value) return list
  return list.filter(m => m.type === typeFilter.value)
})

const searchFiltered = computed(() => {
  const list = typeFiltered.value
  if (!searchQuery.value.trim()) return list
  const query = searchQuery.value.toLowerCase()
  return list.filter(m => {
    const title = (m.title || '').toLowerCase()
    const description = (m.description || '').toLowerCase()
    return title.includes(query) || description.includes(query)
  })
})

const perPage = ref(12)
const currentPage = ref(1)
const filteredTotalPages = computed(() => Math.max(1, Math.ceil(searchFiltered.value.length / perPage.value)))
const filteredTotal = computed(() => searchFiltered.value.length)

const paginatedMaterials = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  const end = start + perPage.value
  return searchFiltered.value.slice(start, end)
})

watch([statusFilter, typeFilter, searchQuery, perPage], () => {
  currentPage.value = 1
})

const goToPage = (page: number) => {
  currentPage.value = page
}

const fetchData = async () => {
  loading.value = true
  error.value = ''
  try {
    const [materialsRes, formsRes] = await Promise.all([
      materialService.fetchAll({ per_page: 1000 }),
      completedFormService.fetchAll(),
    ])
    materials.value = Array.isArray(materialsRes) ? materialsRes : (Array.isArray(materialsRes.data) ? materialsRes.data : [])
    completedForms.value = formsRes
  } catch (err: any) {
    error.value = err.message || 'Failed to fetch data'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchData()
})

const handleView = (m: Material) => {
  if (m.type === 'Online form') {
    router.push({ name: 'employee-view-online-form', params: { id: m.id } })
  } else {
    selectedMaterial.value = m
    showDetailsModal.value = true
  }
}

const handlePrint = async (m: Material) => {
  if (!m.file_path) return
  const loadingToast = toast.info('Preparing document for printing...', { timeout: false })
  try {
    await materialService.printFile(m.id)
    toast.dismiss(loadingToast)
    toast.success('Document printed successfully', { timeout: toastTimeout })
  } catch (err: any) {
    toast.dismiss(loadingToast)
    toast.error(err.response?.data?.message || err.message || 'Failed to print file', { timeout: toastTimeout })
  }
}

const handleDownload = async (m: Material) => {
  const loadingToast = toast.info('Preparing document for download...', { timeout: false })
	try {
		const token = localStorage.getItem('token')
		const url = materialService.getDownloadUrl(m.id)
		const response = await fetch(url, {
			headers: token ? { Authorization: `Bearer ${token}` } : {},
		})
		if (!response.ok) throw new Error('Invalid File')
		const blob = await response.blob()
		const downloadUrl = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = downloadUrl
		a.download = m.title || 'download'
		document.body.appendChild(a)
		a.click()
		window.URL.revokeObjectURL(downloadUrl)
		document.body.removeChild(a)
    toast.dismiss(loadingToast)
    toast.success('Document downloaded successfully', { timeout: toastTimeout })
	} catch (err: any) {
    toast.dismiss(loadingToast)
		toast.error(err.response?.data?.message || err.message || 'Failed to download file', { timeout: toastTimeout })
	}
}

const openSubmitModal = (m: Material) => {
  currentFormMaterial.value = m
  selectedFiles.value = []
  isDragOver.value = false
  showSubmitModal.value = true
}

const handleFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  if (target.files) {
    selectedFiles.value = [...selectedFiles.value, ...Array.from(target.files)]
  }
  target.value = ''
}

const onDrop = (e: DragEvent) => {
  isDragOver.value = false
  if (e.dataTransfer?.files) {
    selectedFiles.value = [...selectedFiles.value, ...Array.from(e.dataTransfer.files)]
  }
}

const removeFile = (index: number) => {
  selectedFiles.value.splice(index, 1)
}

const submitForm = async () => {
  if (!currentFormMaterial.value || selectedFiles.value.length === 0) return
  submitting.value = true
  try {
    const formData = new FormData()
    formData.append('material_id', String(currentFormMaterial.value.id))
    for (const file of selectedFiles.value) {
      formData.append('files[]', file)
    }
    const res = await completedFormService.create(formData) as any
    if (res && res.material_id) {
      completedForms.value.push({
        form_id: 0,
        fk_material_id: res.material_id,
        material_id: res.material_id,
        user_id: userId.value,
        status: 'submitted',
      } as any)
    }
    toast.success(`${selectedFiles.value.length} file(s) submitted successfully`, { timeout: toastTimeout })
    showSubmitModal.value = false
    selectedFiles.value = []
    currentFormMaterial.value = null
  } catch (err) {
    toast.error('Failed to submit form', { timeout: toastTimeout })
  } finally {
    submitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-2xl sm:text-3xl lg:text-4xl font-bold text-primary dark:text-secondary" }, " My Materials "),
        _createElementVNode("p", { class: "text-sm text-slate-500 dark:text-slate-200 mt-2" }, " View assigned materials, online forms, and documents. ")
      ])
    ], -1)),
    _createVNode(TableControls, {
      search: searchQuery.value,
      "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      status: statusFilter.value,
      "onUpdate:status": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
      perPage: perPage.value,
      "onUpdate:perPage": _cache[2] || (_cache[2] = ($event: any) => ((perPage).value = $event)),
      options: statusOptions,
      filterLabel: "Status",
      placeholder: "Search materials...",
      class: "md:sticky md:top-[80px]"
    }, null, 8, ["search", "status", "perPage"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (type) => {
        return _createElementVNode("button", {
          key: type.value,
          onClick: ($event: any) => (typeFilter.value = type.value),
          class: _normalizeClass(["px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap", typeFilter.value === type.value ? 'bg-primary text-white shadow-sm' : 'bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700'])
        }, _toDisplayString(type.label), 11, _hoisted_3)
      }), 64))
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("tbody", null, [
                _createVNode(TableLoader, {
                  colspan: 1,
                  title: "Fetching Materials"
                })
              ])
            ])
          ]))
        : (paginatedMaterials.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMaterials.value, (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m.id,
                  class: "relative bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/50 dark:border-slate-700/50 p-5 flex flex-col overflow-hidden"
                }, [
                  (isCompleted(m))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("div", { class: "absolute top-[23px] right-[-44px] rotate-45 bg-emerald-600 text-white text-[10px] font-bold uppercase px-10 py-1 shadow-md tracking-wider" }, "Completed", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
					'inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-lg',
					m.type === 'Doc File'
					? 'bg-amber-100 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400'
					: m.type === 'Online form'
					? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400'
					: m.type === 'URL Link'
					? 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400'
					: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'
				])
                    }, [
                      (m.type === 'Doc File')
                        ? (_openBlock(), _createBlock(_unref(FileText), {
                            key: 0,
                            class: "h-3.5 w-3.5 text-amber-700"
                          }))
                        : (m.type === 'Online form')
                          ? (_openBlock(), _createBlock(_unref(Globe), {
                              key: 1,
                              class: "h-3.5 w-3.5 text-blue-700"
                            }))
                          : (m.type === 'URL Link')
                            ? (_openBlock(), _createBlock(_unref(Link2), {
                                key: 2,
                                class: "h-3.5 w-3.5 text-purple-700"
                              }))
                            : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(m.type), 1)
                    ], 2),
                    (m.type === 'Doc File')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_unref(Info), { class: "h-3.5 w-3.5 text-yellow-600 cursor-help" }),
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "absolute top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block w-52 bg-slate-800 text-white text-xs rounded px-2 py-1 shadow-lg whitespace-normal text-center z-[9999]" }, [
                            _createTextVNode(" Download the document, fill it out, then click Submit to upload your completed file. "),
                            _createElementVNode("span", { class: "absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-slate-800" })
                          ], -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(m.title), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(m.description || 'No description provided.'), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (m.type === 'Online form' && isCompleted(m))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_14, [
                          _createVNode(_unref(CheckCircle), { class: "h-3.5 w-3.5 shrink-0" }),
                          _cache[12] || (_cache[12] = _createTextVNode(" Completed ", -1))
                        ]))
                      : ((m.type === 'Online form' || m.file_path || m.type === 'URL Link') && !isCompleted(m))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (handleView(m)),
                            class: "group inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white transition-all",
                            title: "View Details"
                          }, [
                            _createVNode(_unref(ViewIcon), { class: "h-4 w-4 shrink-0" }),
                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "overflow-hidden transition-all duration-200 max-w-0 group-hover:max-w-[120px] opacity-0 group-hover:opacity-100 whitespace-nowrap" }, " Details ", -1))
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true),
                    (m.type === 'URL Link' && isCompleted(m))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_16, [
                          _createVNode(_unref(CheckCircle), { class: "h-3.5 w-3.5 shrink-0" }),
                          _cache[14] || (_cache[14] = _createTextVNode(" Completed ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (m.type === 'Doc File' && isCompleted(m))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_17, [
                          _createVNode(_unref(CheckCircle), { class: "h-3.5 w-3.5 shrink-0" }),
                          _cache[15] || (_cache[15] = _createTextVNode(" Completed ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    ((m.type === 'Doc File' || m.type === 'URL Link') && !isCompleted(m))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (m.file_path)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (handlePrint(m)),
                                class: "group inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700 hover:text-slate-600 dark:hover:text-slate-300 transition-all",
                                title: "Print Document"
                              }, [
                                _createVNode(_unref(Printer), { class: "h-4 w-4 shrink-0" }),
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "overflow-hidden transition-all duration-200 max-w-0 group-hover:max-w-[80px] opacity-0 group-hover:opacity-100 whitespace-nowrap" }, " Print ", -1))
                              ], 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          (m.file_path)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: ($event: any) => (handleDownload(m)),
                                class: "group inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg text-primary hover:bg-primary hover:text-white transition-all",
                                title: "Download Document"
                              }, [
                                _createVNode(_unref(DownloadIcon), { class: "h-4 w-4 shrink-0" }),
                                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "overflow-hidden transition-all duration-200 max-w-0 group-hover:max-w-[100px] opacity-0 group-hover:opacity-100 whitespace-nowrap" }, " Download ", -1))
                              ], 8, _hoisted_19))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openSubmitModal(m)),
                            class: "group inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg text-emerald-600 hover:bg-emerald-600 hover:text-white transition-all",
                            title: "Submit Completed Form"
                          }, [
                            _createVNode(_unref(Send), { class: "h-4 w-4 shrink-0" }),
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "overflow-hidden transition-all duration-200 max-w-0 group-hover:max-w-[80px] opacity-0 group-hover:opacity-100 whitespace-nowrap" }, " Submit ", -1))
                          ], 8, _hoisted_20)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, " No materials found matching your criteria. ")),
    (!loading.value && !error.value && filteredTotal.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (!loading.value && !error.value && filteredTotal.value > 0)
              ? (_openBlock(), _createBlock(PaginationBar, {
                  key: 0,
                  "current-page": currentPage.value,
                  "total-pages": filteredTotalPages.value,
                  total: filteredTotal.value,
                  "per-page": perPage.value,
                  "onUpdate:page": goToPage
                }, null, 8, ["current-page", "total-pages", "total", "per-page"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(MaterialDetailsModal, {
      "is-open": showDetailsModal.value,
      material: selectedMaterial.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => {showDetailsModal.value = false; selectedMaterial.value = null})
    }, null, 8, ["is-open", "material"]),
    _createVNode(Modal, {
      modelValue: showSubmitModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showSubmitModal).value = $event)),
      title: "Submit Completed Form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "px-4 py-2 border rounded-lg dark:border-slate-600",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showSubmitModal.value = false))
        }, "Cancel"),
        _createElementVNode("button", {
          type: "button",
          class: "ml-2 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700",
          disabled: selectedFiles.value.length === 0 || submitting.value,
          onClick: submitForm
        }, _toDisplayString(submitting.value ? 'Submitting...' : 'Submit Form'), 9, _hoisted_33)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", _hoisted_25, [
            _cache[19] || (_cache[19] = _createTextVNode("Please upload your completed form for ", -1)),
            _createElementVNode("strong", null, _toDisplayString(currentFormMaterial.value?.title), 1),
            _cache[20] || (_cache[20] = _createTextVNode(".", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-2xl border-2 border-dashed p-6 cursor-pointer select-none bg-white/60 dark:bg-gray-800/50 border-gray-300/70 dark:border-gray-600/60 hover:bg-white/80 dark:hover:bg-gray-800/70", isDragOver.value ? 'ring-2 ring-primary/50 border-primary/60' : '']),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (fileInputRef.value?.click())),
            onDragenter: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (isDragOver.value = true), ["prevent"])),
            onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (isDragOver.value = true), ["prevent"])),
            onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (isDragOver.value = false), ["prevent"])),
            onDrop: _withModifiers(onDrop, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_unref(Upload), { class: "h-5 w-5" })
              ]),
              _createElementVNode("div", _hoisted_28, [
                (selectedFiles.value.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("p", _hoisted_29, _toDisplayString(selectedFiles.value.length) + " file(s) selected", 1),
                      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Click or drop to add more files", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-800 dark:text-gray-100" }, "Drag & drop your files here", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "or click to browse", -1))
                    ], 64))
              ])
            ])
          ], 34),
          (selectedFiles.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFiles.value, (file, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "flex items-center justify-between text-sm text-slate-600 dark:text-slate-300 bg-slate-50 dark:bg-slate-800 rounded-lg px-3 py-1.5"
                  }, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(file.name), 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (removeFile(i)),
                      class: "text-red-500 hover:text-red-700 ml-2 shrink-0"
                    }, [
                      _createVNode(_unref(X), { class: "h-4 w-4" })
                    ], 8, _hoisted_32)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref_key: "fileInputRef",
            ref: fileInputRef,
            type: "file",
            class: "hidden",
            multiple: "",
            onChange: handleFileChange
          }, null, 544)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})